import { API_URL } from '../config/connect';

const request = async (path, { method = 'GET', body } = {}) => {
    const googleIdToken = localStorage.getItem("google_id_token");
    const response = await fetch(`${API_URL}${path}`, {
        method,
        headers: {
            'Accept': 'application/json',
            ...(body !== undefined ? { 'Content-Type': 'application/json' } : {}),
            Authorization: `Bearer ${googleIdToken}`,
        },
        body: body !== undefined ? JSON.stringify(body) : undefined,
    });
    if (!response.ok) {
        const errorBody = await response.json().catch(() => ({ message: response.statusText }));
        const detail = errorBody.detail;
        const errorMessage =
            (typeof detail === 'string' && detail) ||
            detail?.[0]?.msg ||
            detail?.message ||
            errorBody.message ||
            JSON.stringify(errorBody);
        const error = new Error(`Error ${response.status}: ${errorMessage}`);
        error.status = response.status;
        error.detail = errorMessage;
        throw error;
    }
    return response.json();
};

/**
 * Список пользователей с пагинацией и расширенным поиском.
 * @param {Object} params
 * @param {number} [params.page=1]
 * @param {number} [params.limit=10]
 * @param {string} [params.q] - общий поиск по имени/email/телефону
 * @param {string} [params.email] - точный поиск по email
 * @param {string} [params.phone_number] - точный поиск по телефону
 * @param {string} [params.user_type] - фильтр по роли (admin, moderator, operator, individual, business и т.п.)
 * @param {boolean} [params.is_active] - фильтр по статусу аккаунта
 */
const getAdminUsers = async (params = {}) => {
    const { page = 1, limit = 10, q, email, phone_number, user_type, is_active, is_verified, created_from, created_to, activity, sort } = params;
    const qs = new URLSearchParams({ page, limit });
    if (q) qs.set('q', q);
    if (email) qs.set('email', email);
    if (phone_number) qs.set('phone_number', phone_number);
    if (user_type) qs.set('user_type', user_type);
    if (typeof is_active === 'boolean') qs.set('is_active', String(is_active));
    if (typeof is_verified === 'boolean') qs.set('is_verified', String(is_verified));
    if (created_from) qs.set('created_from', created_from);
    if (created_to) qs.set('created_to', created_to);
    if (activity) qs.set('activity', activity);
    if (sort && sort !== 'created_desc') qs.set('sort', sort);
    return request(`/api/v1/admin/users?${qs.toString()}`);
};

/** Полный профиль: данные, подписка, объявления, сессии, последние транзакции. */
const getAdminUserById = (userId) => request(`/api/v1/admin/user/${userId}`);

/** Возвращает { message, user } — обновлённый полный профиль. */
const updateAdminUser = (userId, payload) =>
    request(`/api/v1/admin/user/${userId}`, { method: 'PATCH', body: payload });

/** Запрещает вход и завершает все сессии пользователя. */
const deactivateAdminUser = (userId, reason) =>
    request(`/api/v1/admin/user/${userId}/deactivate`, { method: 'POST', body: { reason: reason || null } });

const activateAdminUser = (userId) =>
    request(`/api/v1/admin/user/${userId}/activate`, { method: 'POST', body: {} });

/** Ручная смена тарифа (только ADMIN, без списания): { tariff_id | null, expires_at: 'YYYY-MM-DD', grant_vip_hours } → полный профиль. */
const setAdminUserSubscription = (userId, body) =>
    request(`/api/v1/admin/user/${userId}/subscription`, { method: 'PUT', body });

export { getAdminUsers, getAdminUserById, updateAdminUser, deactivateAdminUser, activateAdminUser, setAdminUserSubscription };
